import {WidgetType, widgetTypeName as name} from "../models/WidgetType";

export const WidgetTypeName = "tfWidgetTypeName";

export function widgetTypeName() {
    return function(type: WidgetType | null): string {
        if (type == null) {
            return "";
        } else {
            return name(type);
        }
    };
}